
import * as angular from "angular";
import { IRegisterTab } from "./IRegisterTab";
import "./veriTab.scss";

export interface IVeriTab <T = any>{
    tabTitle: string;
    url?: string;
    tabCount?: number
    tabDisabled?: boolean;
    location?: string;

    data?: T;
}

export interface IVeriTabBindings extends IVeriTab {
    tabSubtitle: string;
    preferredOrder: number;

    scroll: boolean;
    tabVisible: boolean;
    warn: boolean;
    loading: boolean;
    alignRight: boolean;
    borderLeft: boolean;
    tabCountLabel: string;
    icon: string;

    stepWidth?: number;

    tabTooltip: string;
    tabTooltipDirection: string;

    tabReference: number;

    onTabSelected: () => void;

    show(animate: boolean);
    hide(animate: boolean);
    setClassName(className: string);

    disableNextButton?: boolean;
    nextButtonLabel: string;
    nextButtonFunction: () => angular.IPromise<void>;
}

export class VeriTabComponentController implements angular.IComponentController, IVeriTabBindings {

    tabTitle: string = "unset";
    tabSubtitle: string;
    preferredOrder: number = 0;

    tabCount: number = null;
    tabCountLabel: string;
    badgeCount: number = null;
    scroll: boolean;
    tabDisabled: boolean;
    tabVisible: boolean;
    url: string;
    warn: boolean;
    loading: boolean;
    alignRight: boolean;
    borderLeft: boolean;
    icon: string;

    tabTooltip: string;
    tabTooltipDirection: string;
    tabReference: number;

    onTabSelected: () => void;

    hideTimeout: angular.IPromise<any>;
    className = "";
    visible = false;

    parent: IRegisterTab;
    veriTabs: IRegisterTab;
    veriVerticalTabs: IRegisterTab;

    disableNextButton?: boolean;
    nextButtonLabel: string;
    nextButtonFunction: () => angular.IPromise<void>;

    static $inject = ["$element", "$timeout"];

    constructor(private readonly $element: JQuery, private readonly $timeout: angular.ITimeoutService) {}

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        if (onChangesObj["tabVisible"] && !onChangesObj["tabVisible"].isFirstChange()) {
            this.parent.tabVisibilityChanged(this);
        }

        if (onChangesObj["tabSelected"] && onChangesObj["tabSelected"].currentValue) {
            this.$timeout(() => {
                this.parent.showTab(this, false);
            });
        }
    }

    $onInit() {
        this.parent = this.veriVerticalTabs || this.veriTabs;
        this.hide(false);

        if (this.parent) {
            this.parent.registerTab(this);
        }
        else {
            console.error("VeriTab used outside of VeriTabs");
            return;
        }

        if (this.scroll !== false) {
            this.scroll = true;
        }

        this.tabVisible = this.tabVisible === false ? false : true;
    }

    $onDestroy() {
        this.parent.unregisterTab(this);
    }

    show(animate: boolean) {
        if (this.hideTimeout) {
            this.$timeout.cancel(this.hideTimeout);
        }

        this.visible = true;

        if (this.onTabSelected) {
            this.onTabSelected();
        }

        // This allows the tabs to autoresize, not perfect, commented out for now
        //this.$timeout(() => {

        //    var child = this.$element.children().first();
        //    var subchild = child.children().first();

        //    var elementToUse = child;

        //    //if (subchild.length > 0) {
        //    //    elementToUse = subchild;
        //    //}

        //    var height = elementToUse.outerHeight();
        //    console.log("e", elementToUse);
        //    console.log("c", subchild);
        //    //console.log("outer height", height);

        //    if (elementToUse[0]) {
        //        console.log("scroll height", elementToUse[0].scrollHeight);
        //        height = Math.max(height, elementToUse[0].scrollHeight);
        //    }

        //    //this.$element[0].style["min-height"] = `${height}px`;

        //    //this.$timeout(() => {
        //    //    this.parent.setContentHeight(null);
        //    //}, 1000);

        //    this.parent.setContentHeight(height);
        //}, 100);
    }

    hide(animate: boolean) {
        if (animate) {
            this.hideTimeout = this.$timeout(() => { this.visible = false; }, 500);
        }
        else {
            this.visible = false;
        }
    }

    setClassName(className: string) {
        if (this.className === className) {
            return;
        }

        if (this.className) {
            this.$element.removeClass(this.className);
        }

        if (className) {
            this.className = className;
            this.$element.addClass(this.className);
        }
    }
}

export class VeriTabComponent implements angular.IComponentOptions {
    bindings: any;
    require: any;
    controller: any;
    template: string;
    transclude: boolean | { [index: string]: string; };

    constructor() {
        this.bindings = {
            url: "@",
            tabTitle: "@",
            tabSubtitle: "@",
            preferredOrder: "<?",

            tabCount: "<",
            tabCountLabel: "@",

            badgeCount: "<",
            tabDisabled: "<",

            tabVisible: "<",
            tabSelected: "<",

            tabTooltip: "<",
            tabTooltipDirection: "<",

            scroll: "<",
            warn: "<?",
            icon: "@?",
            loading: "<?",
            alignRight: "@",
            borderLeft: "@",

            onTabSelected: "&",

            tabReference: "<?reference",

            disableNextButton: "<",
            nextButtonLabel: "@?",
            nextButtonFunction: "&",
            location: "@"
        };

        this.controller = VeriTabComponentController;
        this.template = require("./veriTab.html");
        this.transclude = true;
        this.require = {
            veriTabs: "?^veriTabs",
            veriVerticalTabs: "?^veriVerticalTabs"
        };
    }
}
